import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { MsalGuard } from '@azure/msal-angular';
// import { environment } from 'src/environments/environment';

import { AuthModule } from './auth/auth.module';
import { DocumentViewerComponent } from '@via/standalone';
// import { loginGuard } from './shared-global/guards/login.guard';

// const guards: any[] = environment.IsSSO ? [loginGuard, MsalGuard] : [];
const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'app',
  },
  {
    path: 'auth',
    loadChildren: () => AuthModule,
  },
  {
    matcher: (segments) => {
      const regexPattern = /^code.*$/i;
      const [firstSegment] = segments;
      const isMatch = regexPattern.test(firstSegment.path);
      return isMatch ? { consumed: segments } : null;
    },
    redirectTo: 'app',
  },
  {
    path: 'app',
    // canActivate: guards,
    loadChildren: () =>
      import('./layout/layout.module').then((m) => m.LayoutModule),
  },
  {
    path: 'document-viewer/:stream/:uniqueId/:documentName',
    component: DocumentViewerComponent,
    title: 'Document Viewer',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
